import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { stagedActionEventProperties } from '@renderer/overlay/Sidepanel/hooks/staged-actions/track-staged-action'
import type { StagedAction } from '../../hooks/use-staged-actions'

type ActionViewEvent = 'invoke' | 'open-in-app' | 'undo' | 'archive' | 'restore' | 'discard-edit' | 'add-todo'

/**
 * Amplitude event for anything the user does to an action from the Action View.
 * Shared by the footer regions so `source: 'action-view'` is stamped once —
 * the cell and the hover card report the same events under their own source.
 */
export function trackActionEvent(action: StagedAction, event: ActionViewEvent, extra?: Record<string, unknown>) {
  AmplitudeRenderer.trackEvent('Staged Action', {
    action: event,
    ...stagedActionEventProperties(action),
    source: 'action-view',
    ...extra,
  })
}
